<template>
  <div class="mx-auto my-2">
    <v-card class="mx-4" flat>
      <v-card-title>
        Menu Items
        <v-spacer></v-spacer>
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            hide-details
            label="Search"
            single-line
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn v-if="canCreateMenuItems" class="teal white--text" depressed @click="addMenuItem()">
          <v-icon left>mdi-plus-circle</v-icon>
          <span>Add Menu Item</span>
        </v-btn>
      </v-card-title>
      <v-data-table
          :headers="headers"
          :items="menuItems.rows"
          :loading="loading"
          :options.sync="options"
          :server-items-length="menuItems.count"
          class="elevation-1"
          loading-text="Loading... please wait"
      >
        <template v-slot:[`item.menuItemName`]="{ item }">
          <label for="item">{{
              item.menuItemName ? item.menuItemName : "-"
            }}</label>
        </template>
        <template v-slot:[`item.url`]="{ item }">
          <label for="item">{{
              item.url ? item.url : "-"
            }}</label>
        </template>
        <template v-slot:[`item.icon`]="{ item }">
          <label for="item">{{
              item.icon ? item.icon : "-"
            }}</label>
        </template>
        <template v-slot:[`item.menuItemCode`]="{ item }">
          <label for="item">{{
              item.menuItemCode ? item.menuItemCode : "-"
            }}</label>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-if="canEditMenuItems" v-slot:activator="{ on }">
              <v-icon
                  class="mr-2"
                  style="color: teal"
                  @click="editMenuItem(item)"
                  v-on="on"
              >mdi-circle-edit-outline
              </v-icon
              >
            </template>
            <span>Edit Menu Item</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>

    <template>
      <v-dialog v-model="dialog" persistent width="60%">
        <v-card>
          <v-card-title
              class="headline font-weight-regular blue-grey white--text"
              primary-title
          >{{ title }}

            <v-spacer></v-spacer>

            <v-btn color="white" text @click="closeDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title
          >
          <v-divider></v-divider>
          <HrdAddMenuItem
              v-if="dialog"
              :menuItem="menuItem"
              @close="closeDialog()"
              @registerOrUpdateMenuItem="registerOrUpdateMenuItem"
          ></HrdAddMenuItem>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>


<script>
import HrdAddMenuItem from "./hrd-add-menuitem";
import {MenuItemService} from "./menuItem.service";
import {getUser} from "@/utils/helper";

export default {
  components: {
    HrdAddMenuItem,
  },

  data() {
    return {
      dialog: false,
      title: "",
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      search: "",
      searchDebounce: null,
      menuItems: [],
      headers: [
        {text: "Name", value: "menuItemName"},
        {text: "URL", value: "url"},
        {text: "Icon", value: "icon"},
        {text: "Code", value: "menuItemCode"},
        {text: "Actions", value: "actions", sortable: false, align: "center"},
      ],
      loading: false,
      menuItem: null,
    };
  },
  async beforeMount() {
    this.fetchMenuItems();
  },
  watch: {
    options: {
      handler() {
        this.fetchMenuItems();
      },
      deep: true,
    },
    search: function (val) {
      if (this.searchDebounce) {
        clearTimeout(this.searchDebounce);
        this.searchDebounce = null;
      }
      const text = (val || "").toString().trim();
      if (text.length === 0) {
        this.fetchMenuItems();
        return;
      }
      if (text.length < 3) {
        return;
      }
      this.searchDebounce = setTimeout(() => {
        this.fetchMenuItems();
      }, 400);
    },
  },
  computed: {
    canCreateMenuItems() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "Menu Items" && permission.canCreate
      );
    },
    canEditMenuItems() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "Menu Items" && permission.canUpdate
      );
    },
  },
  methods: {
    async fetchMenuItems() {
      this.loading = true;
      const {page, itemsPerPage} = this.options;
      const res = await MenuItemService.getMenuItemsWP(
          page,
          itemsPerPage,
          this.search
      );
      if (res.status === 200) {
        this.loading = false;
        this.menuItems = res.data;
      } else {
        this.loading = false;
        this.$toast.error(
            "There was a problem fetching menu items, Please try Again!"
        );
      }
    },

    addMenuItem() {
      this.menuItem = null;
      this.dialog = true;
      this.title = "Add Menu Item";
    },
    editMenuItem(item) {
      this.menuItem = item;
      this.dialog = true;
      this.title = "Edit Menu Item";
    },
    closeDialog() {
      this.dialog = false;
      this.fetchMenuItems();
    },
    async registerOrUpdateMenuItem(menuItem) {
      let res = null;

      if (menuItem.editMode) {
        res = await MenuItemService.update(menuItem.id, menuItem);

        if (res.status === 200) {
          switch (res.data.resultCode) {
            case 1:
              this.$toast.success(res.data.message);
              this.fetchMenuItems();
              break;
            case 0:
              this.$toast.error(res.data.message);
              break;
          }
        } else {
          this.$toast.error("Unable to update menu Item, please try again");
        }
      } else {
        res = await MenuItemService.create(menuItem);

        if (res.status === 200) {
          switch (res.data.resultCode) {
            case 1:
              this.$toast.success(res.data.message);
              this.fetchMenuItems();
              break;
            case 0:
              this.$toast.error(res.data.message);
              break;
          }
        } else {
          this.$toast.error("Unable to create menu Item, please try again");
        }
      }
    },
  },
};
</script>
<style scoped>
</style>
